






























































// vue
import { defineComponent, PropType, ref, computed } from '@vue/composition-api'

// components
import { Select, Select2 } from '../form'

// constants
import {
    optionsWorkType,
    optionsWorkCategory
} from '@/constants'

// models
import { AreaModel, HeadquarterModel } from '@/models/config'
import { PropOptionSelect } from '@/models'
import { FiltersFormModel } from '@/models/taskSheet'

export default defineComponent({
  name: 'FiltersFormTaskSheet',
  components: {
    Select2,
    Select
  },
  props: {
    areas: {
      required: true,
      type: Array as PropType<AreaModel[]>
    },
    filters: {
      required: true,
      type: Object as PropType<FiltersFormModel>
    },
    headquarters: {
      required: true,
      type: Array as PropType<HeadquarterModel[]>
    },
    actionForm: {
      required: true,
      type: String as PropType<string>
    }
  },
  setup (props) {
    const opWorkType = ref(optionsWorkType)
    const opWorkCategory = ref(optionsWorkCategory)

    const areasOptions = computed(() => {
      const areas: PropOptionSelect[] = []
      props.areas.forEach(area => {
        if (area.id) {
          areas.push({
            text: area.name,
            value: area.id
          })
        }
      })
      return areas
    })

    const subAreas = computed(() => {
      const areaSelected = props.areas.find(area => area.id === props.filters.areaId)
      if (areaSelected) {
        const subAreasInArea = areaSelected.subAreas
        const subAreas: PropOptionSelect[] = []
        if (subAreasInArea) {
          subAreasInArea.forEach(sub => {
            subAreas.push({
              text: sub.name,
              value: sub?.id ? sub.id : null
            })
          })
        }
        return subAreas
      }
      return []
    })

    const headquarterOp = computed(() => {
      const headquarters: PropOptionSelect[] = []
      props.headquarters.forEach(headq => {
        if (headq.id) {
          headquarters.push({
            value: headq.id,
            text: headq.name
          })
        }
      })
      return headquarters
    })

    return {
      opWorkType,
      opWorkCategory,
      areasOptions,
      subAreas,
      headquarterOp
    }
  }
})
